import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {RequestBody} from "../../interfaces/admin.interface";
import {
    BusinessConsultant,
    NominativeContact,
    NominativeData,
    NominativeInfo,
    NominativeListRequestBody,
    SubcontractorUpload
} from "../../interfaces/name-list.interface";
import {LoggingService} from "../log.service";
import {RestfulService} from "../restful.service";
import * as ENDPOINT from "../../../shared/constant/endPoint.js";
import {getEndPointWithParams} from "../../../../assets/js/util";
import {BaseService, EndPoint, ListService} from "../../classes/baseService";

class NominativeEndPoint extends EndPoint {

    searchGoStock: string
    businessConsultant: string
    subcontractorDocuments: string = this.fill('/:id/subcontractor-documents')
    subcontractorUpload: string = this.fill('/:id/subcontractor/upload')

    constructor(baseUrl: string, standard: boolean, paths: []) {
        super(baseUrl, standard, paths);
        this.searchGoStock = this.fill('/search/:company/go-stock')
        this.businessConsultant = this.fill('/:id/business-consultant')
    }

}
@Injectable({
    providedIn: 'root'
})
export class NominativeService extends BaseService<NominativeInfo, NominativeData> implements ListService<NominativeListRequestBody> {

    public static endPoint = new NominativeEndPoint('account', true, [])

    constructor(
        logger: LoggingService,
        restful: RestfulService,
    ) {
        super(logger, restful)
        this.endPoint = NominativeService.endPoint
    }

    protected override getDefaultDto(): NominativeInfo {
        return new NominativeInfo();
    }

    list(reqBody: RequestBody) {
        return this.listImpl(NominativeService.endPoint.paths.find, reqBody)
    }

    override getRecord(nominativeId: number): Observable<any> {
        return this.getRecordImpl(nominativeId, NominativeService.endPoint.paths.findInfo);
    }

    searchNominativeInfo(taxId: string): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.account_search, taxId);
        const getter = this.get(endPoint);
        return getter;

    }

    save(reqBody: NominativeData, id?: number) {
        this.saveImpl(reqBody, id != null ? NominativeService.endPoint.paths.update : NominativeService.endPoint.paths.create, id)
    }

    public nextCode(company: number): Observable<any> {
        const getter = this.get(`/${this.endPoint.baseUrl}/code/${company}/next`);
        return getter;
    }

    saveBusinessConsultant(req: BusinessConsultant, idNominative: number) {
        const endPoint = getEndPointWithParams(NominativeService.endPoint.businessConsultant, idNominative);
        return this.put(endPoint, req);
    }

    getSubcontractorDocuments(idNominative: number): Observable<any> {
        const endPoint = getEndPointWithParams(NominativeService.endPoint.subcontractorDocuments, idNominative);
        return this.get(endPoint);
    }

    uploadSubcontractorDocuments(idNominative: number, upload: SubcontractorUpload): Observable<any> {
        const endPoint = getEndPointWithParams(NominativeService.endPoint.subcontractorUpload, idNominative);
        return this.post(endPoint, upload);
    }

    getContactList(idNominative: number): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.nominative_contact, idNominative);
        return this.get(endPoint);
    }

    createContact(idNominative: number, contact: NominativeContact): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.nominative_contact, idNominative);
        return this.post(endPoint, contact);
    }

    updateContact(idContact: number, contact: NominativeContact): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.nominative_contact_byid, idContact);
        return this.put(endPoint, contact);
    }

    deleteContact(idContact: number): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.nominative_contact_byid, idContact);
        return this.delete(endPoint);
    }

    toggleContact(idContact: number): Observable<any> {
        const endPoint = getEndPointWithParams(ENDPOINT.nominative_contact_byid, idContact);
        return this.put(endPoint, {});
    }

}
